export default {
  data: function () {
    return {
      navbarHide: 'relative',
      navbarShow: '',
    }
  },
  computed: {
    Logo() {
      return require(`@src/assets/images/websiteLogPurple.svg`)
    },
  },
  methods: {
    initials(name) {
      let initials = ''
      name.split(' ').forEach((el, index) => {
        if (el !== '') initials += el[0]
      })
      return initials.substring(0, 2).toUpperCase()
    },
    setnavbarHide(value) {
      if (value === true) {
        this.navbarHide = ''
        this.navbarShow = 'relative'
      } else {
        this.navbarHide = 'relative'
        this.navbarShow = ''
      }
    },
  },
}
